<template>
  <form @submit.prevent="onSubmit">
    <ul>
      <li v-for="(address, key) in localAddresses" :key="key" :class="[address.type==='new' && $style.rowNew]">
        <div class="flex mb-4">
          <vs-input
            class="w-full"
            v-model="localAddresses[key]"
          />
          <vs-button
            class="ml-2"
            color="danger"
            iconPack="feather"
            icon="icon-trash"
            type="border"
            title="Удалить"
            @click="onRemove(key)"
          />
        </div>
      </li>
    </ul>
    <div class="text-center">
      <vs-button
        button="button"
        color="success"
        iconPack="feather"
        icon="icon-plus"
        type="border"
        @click="onAdd"
      >
        Добавить
      </vs-button>
    </div>


    <div class="text-center">
      <vs-button button="submit" type="filled" color="primary" class="">Сохранить</vs-button>
    </div>
  </form>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";
import modalContext    from "@/mixins/modalContext";

export default {
  name:   "BuildingAdditionalAddressesModal",
  props:  ['buildingId', 'addresses'],
  mixins: [notifyHttpError, modalContext],
  data() {
    return {
      localAddresses: this.addresses ? [...this.addresses] : [],
    };
  },
  methods: {
    onSubmit() {
      this.$http.post(`fillform/add_address_to_building`, [{
        "buildings_id":         this.buildingId,
        "additional_addresses": this.localAddresses.map(v => v.trim()).filter(v => v),
      }]).then(() => {
        this.modalResolve();
      });
    },

    onAdd() {
      this.localAddresses.push('');
    },

    onRemove( key ) {
      this.localAddresses.splice(key, 1);
    },
  },
  mounted() {
  },
  watch: {},
};
</script>

<style lang="scss" module>
.rowRemoved {
  background: rgba(var(--vs-danger), .08);
}

.rowNew {
  background: rgba(var(--vs-success), .08);
}
</style>
